import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './About.css';

const EMAILJS_SERVICE_ID  = 'service_5olnapn';
const EMAILJS_TEMPLATE_ID = 'template_gvngdbg';
const EMAILJS_PUBLIC_KEY  = '403pvd05zx0yDvLoX';

export default function About() {
  const [form, setForm] = useState({ name:'', email:'', subject:'', message:'' });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const set = (k,v) => setForm(f => ({...f, [k]:v}));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError('');

    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          from_name:  form.name,
          from_email: form.email,
          subject:    form.subject,
          message:    form.message,
        }
      );
      setSent(true);
    } catch (err) {
      console.error('EmailJS error:', err);
      setError('Something went wrong. Please try again or email us directly at info@the-patch-guys.com');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="about">
      {/* Hero */}
      <section className="about__hero">
        <div className="container">
          <div className="badge badge-gold" style={{marginBottom:'20px'}}>Our Story</div>
          <h1 className="section-title animate-fade-up" style={{color:'white', marginBottom:'16px'}}>About The Patch Guys</h1>
          <p className="animate-fade-up delay-1" style={{color:'rgba(255,255,255,0.65)', fontSize:'17px', maxWidth:'560px', margin:'0 auto', textAlign:'center', lineHeight:'1.7'}}>
            Built by sports parents, for young athletes. We believe every game, every team,
            and every mile traveled deserves to be remembered.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="section about__mission">
        <div className="container about__mission-inner">
          <div className="about__mission-content">
            <div className="tag-line">Why We Built This</div>
            <h2 className="section-title" style={{marginBottom:'20px'}}>Your Journey Deserves a Map</h2>
            <p className="about__mission-text">
              Youth sports travel is an incredible experience — competing against teams from
              across the country, making memories at tournaments, and growing as an athlete.
              But too often those experiences fade. We built The Patch Guys to change that.
            </p>
            <p className="about__mission-text">
              By combining the tradition of patch collecting with modern technology, we've
              created a way for young athletes to document their journey, track their
              achievements, and stay motivated to keep competing.
            </p>
            <p className="about__mission-text">
              Every pin on the map is a story. Every trophy is a milestone. Every patch is
              proof that you showed up and played.
            </p>
          </div>
          <div className="about__mission-stats">
            {[
              { number:'8', label:'Supported Sports', icon:'🏅' },
              { number:'50', label:'States to Conquer', icon:'🗺️' },
              { number:'12', label:'Trophies to Earn', icon:'🏆' },
              { number:'∞', label:'Memories to Make', icon:'⭐' },
            ].map((s,i) => (
              <div key={i} className="about__stat">
                <div className="about__stat-icon">{s.icon}</div>
                <div className="about__stat-number">{s.number}</div>
                <div className="about__stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section about__values" style={{background:'var(--off-white)'}}>
        <div className="container">
          <div style={{textAlign:'center', marginBottom:'56px'}}>
            <div className="tag-line">What We Stand For</div>
            <h2 className="section-title">Our Values</h2>
          </div>
          <div className="about__values-grid">
            {[
              { icon:'🤝', title:'Community First', desc:'We\'re built for the youth sports community — teams, families, and organizers all benefit from the platform.' },
              { icon:'🔒', title:'Privacy by Design', desc:'No unnecessary data. Kids\' accounts are managed by parents. We never sell your data.' },
              { icon:'💡', title:'Simple & Powerful', desc:'Complex technology made simple. If a 10-year-old can\'t figure it out, we\'ve failed.' },
              { icon:'🌎', title:'Every Sport Welcome', desc:'From soccer to field hockey, we celebrate all youth sports and the athletes who play them.' },
            ].map((v,i) => (
              <div key={i} className="about__value-card">
                <div className="about__value-icon">{v.icon}</div>
                <h3 className="about__value-title">{v.title}</h3>
                <p className="about__value-desc">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="section about__contact">
        <div className="container about__contact-inner">
          <div className="about__contact-info">
            <div className="tag-line">Get in Touch</div>
            <h2 className="section-title" style={{marginBottom:'20px'}}>Contact Us</h2>
            <p style={{color:'var(--gray-600)', fontSize:'16px', lineHeight:'1.75', marginBottom:'40px'}}>
              Questions about registering your team? Want to partner with us?
              We'd love to hear from you.
            </p>
            <div className="about__contact-items">
              <div className="about__contact-item">
                <div className="about__contact-item-icon">📧</div>
                <div>
                  <div className="about__contact-item-label">Email</div>
                  <a href="mailto:info@the-patch-guys.com" className="about__contact-item-value">info@the-patch-guys.com</a>
                </div>
              </div>
              <div className="about__contact-item">
                <div className="about__contact-item-icon">📱</div>
                <div>
                  <div className="about__contact-item-label">Social Media</div>
                  <div className="about__contact-item-value">@thepatchguys</div>
                </div>
              </div>
            </div>
          </div>

          <div className="about__contact-form-wrap">
            {sent
              ? <div className="about__contact-success">
                  <div style={{fontSize:'48px', marginBottom:'16px'}}>✅</div>
                  <h3>Message Sent!</h3>
                  <p>We'll get back to you within 1–2 business days.</p>
                  <button className="btn btn-blue" onClick={() => { setSent(false); setForm({ name:'', email:'', subject:'', message:'' }); }}>Send Another</button>
                </div>
              : <form onSubmit={handleSubmit} className="about__contact-form">
                  <div className="form-group">
                    <label className="form-label">Name *</label>
                    <input className="form-input" required value={form.name} onChange={e => set('name', e.target.value)} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Email *</label>
                    <input className="form-input" type="email" required value={form.email} onChange={e => set('email', e.target.value)} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Subject *</label>
                    <select className="form-select" required value={form.subject} onChange={e => set('subject', e.target.value)}>
                      <option value="">Select a topic...</option>
                      <option value="Team Registration Question">Team Registration Question</option>
                      <option value="Event Registration Question">Event Registration Question</option>
                      <option value="App Support">App Support</option>
                      <option value="Partnership Inquiry">Partnership Inquiry</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Message *</label>
                    <textarea className="form-textarea" required value={form.message} onChange={e => set('message', e.target.value)} placeholder="How can we help?" />
                  </div>
                  {error && (
                    <div style={{color:'#e53e3e', fontSize:'13px', marginBottom:'12px', padding:'10px', background:'#fff5f5', borderRadius:'8px', border:'1px solid #fed7d7'}}>
                      {error}
                    </div>
                  )}
                  <button type="submit" className="btn btn-primary" style={{width:'100%', justifyContent:'center'}} disabled={sending}>
                    {sending ? 'Sending...' : 'Send Message'}
                  </button>
                </form>
            }
          </div>
        </div>
      </section>
    </div>
  );
}